// eslint-disable import/no-extraneous-dependencies
import { getAuth, initializeAuth, browserLocalPersistence } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import { firebaseApp } from './firebase';

const getFirebaseAuth = () => {
  if (Capacitor.isNativePlatform()) {
    // Use browserLocalPersistence on native - it's faster than indexedDB on iOS WebViews
    return initializeAuth(firebaseApp, {
      persistence: browserLocalPersistence,
    });
  }
  return getAuth(firebaseApp);
};

const auth = getFirebaseAuth();

export default auth;
